export default {
  ACTIONRESPONSE_CONTAINER: 'ACTIONRESPONSEPOPUP_CONTAINER',
  ACTIONRESPONSE_CLOSE_CLICK: 'ACTIONRESPONSEPOPUP_CLOSE_CLICK',
  ACTIONRESPONSE_HEADER_TITLE_TEXT: 'ACTIONRESPONSEPOPUP_HEADER_TITLE_TEXT',
  ACTIONRESPONSE_ACTION_NAME_TEXT: 'ACTIONRESPONSEPOPUP_ACTION_NAME_TEXT',
  ACTIONRESPONSE_DAY_TEXT: 'ACTIONRESPONSEPOPUP_DAY_TEXT',
  
  ACTORCONVERTED_CONTAINER: 'ACTORCONVERTEDPOPUP_CONTAINER',
  ACTORCONVERTED_CLOSE_CLICK: 'ACTORCONVERTEDPOPUP_CLOSE_CLICK',
  
  ACTOR_CONTAINER: 'ACTORPOPUP_CONTAINER',
  ACTOR_CLOSE_CLICK: 'ACTORPOPUP_CLOSE_CLICK',
  ACTOR_NAME_TEXT: 'ACTORPOPUP_NAME_TEXT',
  ACTOR_DESIGNATION_TEXT: 'ACTORPOPUP_DESIGNATION_TEXT',
  
  ADVISOR_CONTAINER: 'ADVISORPOPUP_CONTAINER',
  ADVISOR_CLOSE_CLICK: 'ADVISORPOPUP_CLOSE_CLICK',
  
  BUUNLOCK_CONTAINER: 'BUUNLOCKPOPUP_CONTAINER',
  BUUNLOCK_CLOSE_CLICK: 'BUUNLOCKPOPUP_CLOSE_CLICK',
  BUUNLOCK_UNLOCK_CLICK: 'BUUNLOCKPOPUP_UNLOCK_CLICK',
  
  EVENTACTION_CONTAINER: 'EVENTACTIONPOPUP_CONTAINER',
  EVENTACTION_CLOSE_CLICK: 'EVENTACTIONPOPUP_CLOSE_CLICK',
  
  LOGOUT_CONTAINER: 'LOGOUTPOPUP_CONTAINER',
  LOGOUT_CONFIRM_CLICK: 'LOGOUTPOPUP_CONFIRM_CLICK',
  LOGOUT_CANCEL_CLICK: 'LOGOUTPOPUP_CANCEL_CLICK',
  
  MENTORTIPS_CONTAINER: 'MENTORTIPSPOPUP_CONTAINER',
  MENTORTIPS_CLOSE_CLICK: 'MENTORTIPSPOPUP_CLOSE_CLICK',
  MENTORTIPS_CONTENT_TEXT: 'MENTORTIPSPOPUP_CONTENT_TEXT',
  
  METRIC_CONTAINER: 'METRICPOPUP_CONTAINER',
  METRIC_CLOSE_CLICK: 'METRICPOPUP_CLOSE_CLICK',
  
  MONTHLYREPORT_CONTAINER: 'MONTHLYREPORTPOPUP_CONTAINER',
  MONTHLYREPORT_CLOSE_CLICK: 'MONTHLYREPORTPOPUP_CLOSE_CLICK',
  
  PENDINGACTIONRESPONSE_CONTAINER: 'PENDINGACTIONRESPONSEPOPUP_CONTAINER',
  PENDINGACTIONRESPONSE_CLOSE_CLICK: 'PENDINGACTIONRESPONSEPOPUP_CLOSE_CLICK',
  
  REPORT_CONTAINER: 'REPORTPOPUP_CONTAINER',
  REPORT_CLOSE_CLICK: 'REPORTPOPUP_CLOSE_CLICK',
  
  STARTSIM_CONTAINER: 'STARTSIMPOPUP_CONTAINER',
  STARTSIM_START_CLICK: 'STARTSIMPOPUP_START_CLICK',
  STARTSIM_CONTENT_TEXT: 'STARTSIMPOPUP_CONTENT_TEXT',
  
  TIMERCOMPLETED_CONTAINER: 'TIMERCOMPLETEDPOPUP_CONTAINER',
  TIMERCOMPLETED_CLOSE_CLICK: 'TIMERCOMPLETEDPOPUP_CLOSE_CLICK',
  TIMERCOMPLETED_MESSAGE_TEXT: 'TIMERCOMPLETEDPOPUP_MESSAGE_TEXT',
  
  TIMERREMINDER_CONTAINER: 'TIMERREMINDERPOPUP_CONTAINER',
  TIMERREMINDER_CLOSE_CLICK: 'TIMERREMINDERPOPUP_CLOSE_CLICK',
  TIMERREMINDER_MESSAGE_TEXT: 'TIMERREMINDERPOPUP_MESSAGE_TEXT',
};

